import type { IconNames } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import type {
  ConversationDirection,
  ConversationStatus,
} from 'lib-shared-types-api';

/** Represents various conversation status attributes. */
export const conversationStatusAttributes: Record<
  ConversationStatus,
  {
    /** The pretty name of the status. */
    readonly label: string;
    /** The color of the status. */
    readonly color: string;
  }
> = {
  open: { label: 'Open', color: colors.green['500'] },
  closed: { label: 'Closed', color: colors.neutral['500'] },
  pending: { label: 'Follow-up', color: colors.neutral['500'] },
  awaitingpending: { label: 'Follow-up', color: colors.blue['500'] },
};

/** Represents various conversation direction attributes. */
export const conversationDirectionAttributes: Record<
  ConversationDirection,
  {
    /** The pretty name of the direction. */
    readonly label: string;
    /** The icon of the direction. */
    readonly icon: IconNames;
  }
> = {
  inbound: { label: 'Inbound', icon: 'square-arrow-down-left' },
  outbound: { label: 'Outbound', icon: 'square-arrow-up-right' },
  internal: { label: 'Internal', icon: 'arrow-square-right' },
};
